/**
 * Wire format for `wp/v2/pages` — only the bits the super-categories
 * editor actually needs.
 *
 * `crb_menus` is the Carbon Fields complex-field that backs
 * super-categories. Each entry has `_type`, name, desc, and a
 * `menu_categories` list of taxonomy references. We narrow that list
 * to `ezcategory` ids for the editor; the api layer round-trips
 * unknown reference kinds verbatim so we don't drop them on save.
 */
import { z } from 'zod'

export const menuCategoryRefSchema = z.object({
  value: z.string().optional(),
  type: z.string().optional(),
  subtype: z.string().optional(),
  id: z.union([z.string(), z.number()]).optional(),
})
export type MenuCategoryRef = z.infer<typeof menuCategoryRefSchema>

export const superCategoryWireSchema = z.object({
  _type: z.string().optional().default('base'),
  name: z.string().optional().default(''),
  desc: z.string().optional().default(''),
  menu_categories: z.array(menuCategoryRefSchema).optional().default([]),
})
export type SuperCategoryWire = z.infer<typeof superCategoryWireSchema>

export const menuPageWireSchema = z.object({
  id: z.number().int().positive(),
  slug: z.string(),
  crb_menus: z.array(superCategoryWireSchema).optional().default([]),
})
export type MenuPageWire = z.infer<typeof menuPageWireSchema>

export const menuPageListWireSchema = z.array(menuPageWireSchema)
